/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import PrivacyLawFirmPageMeta from "./PrivacyLawFirmPageMeta";
import Container from "@/src/components/Container/Container";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import PrivacyLawFirm from "@/src/components/Privacy/PrivacyLawFirm/PrivacyLawFirm";

const PrivacyLawFirmPage = () => {
  return (
    <LayoutPublicRoutes>
      <PrivacyLawFirmPageMeta />
      <Container showVerticalPadding={false}>
        <PrivacyLawFirm />
      </Container>
    </LayoutPublicRoutes>
  );
};

export default PrivacyLawFirmPage;
